import oneIdEvents from "./events/OneIdEvents";

var LinkedConfirmationController = function (
    $scope,
    $location,
    $window,
    PrimaryPlanSelectionFactory,
    redirectService,
    eventBus,
    $translate,
    $cookies,
    SetACCUService,
    accountService,
    $state,
    profileFactory,
    LinkedConfirmationFactory,
    DefaultCustomizationRetrService,
    PreLoginAccuRetrievalService,
    ReSetACCUService,
    $q,
    AccuCodeService,
    $rootScope,
    PreLoginContactInfoService
) {
    var vm = this;
    vm.loading = true;
    vm.error = false;
    var deferred = $q.defer();

    profileFactory.retrieveUserNameForOneid.query(
        {},
        function (data, headers) {
            vm.loading = false;
            vm.userName = data.data.userName;
        },

        function (response) {
            vm.loading = false;
        }
    );

    vm.continueClick = function () {
        vm.loading = true;
        var method = "continueClickFromLinkedConfirmationPage";
        eventBus.dispatch(oneIdEvents.CONFIRMATION_CONTD_CLICK, this);

        LinkedConfirmationFactory.retrieveNextDestination.query(
            {},
            function (data, headers) {
                vm.loading = false;
                var dest = data.data.destinationUrl;
                if (dest !== "participant/#/choose-primaryplan") {
                    redirectService.redirect(data.data, "ALL");
                } else {
                    $state.go("choosePrimaryPlan", { oneIdFlow: "linking" });
                }
            },

            function (response) {
                vm.loading = false;
            }
        );

        $state.go("choosePrimaryPlan", { oneIdFlow: "linking" });
        //$state.go('mailPin', { optOut: 'otp-Expired' });
    };

    var updateCssAccu = function (val) {
        if (val) {
            $rootScope.css.accu = val;
            // eslint-disable-next-line no-undef
            globalThis.css.accu = val;
        } else {
            $rootScope.css.accu = $window.accu;
            // eslint-disable-next-line no-undef
            globalThis.css.accu = $window.accu;
        }
    };
};

LinkedConfirmationController.$inject = [
    "$scope",
    "$location",
    "$window",
    "PrimaryPlanSelectionFactory",
    "redirectService",
    "eventBus",
    "$translate",
    "$cookies",
    "SetACCUService",
    "accountService",
    "$state",
    "profileFactory",
    "LinkedConfirmationFactory",
    "DefaultCustomizationRetrService",
    "PreLoginAccuRetrievalService",
    "ReSetACCUService",
    "$q",
    "AccuCodeService",
    "$rootScope",
    "PreLoginContactInfoService"
];
export default LinkedConfirmationController;
